'use strict';
import { j as t } from "../../external/react/jsx-runtime.js";
import N from "../../external/classnames/index.js";
import { useState as g, useEffect as d } from "react";
import h from "./form.module.scss.js";
const E = ({
  label: n,
  id: s,
  value: u = "",
  placeholder: i,
  onValueChange: e,
  arrows: l,
  style: a
}) => {
  var o, p, c;
  const [m, f] = g(u), x = (r) => {
    f(r);
  };
  return d(() => {
    e && e(m);
  }, [m, e]), /* @__PURE__ */ t.jsxs("div", { className: (o = a == null ? void 0 : a.wrapper) == null ? void 0 : o.className, children: [
    /* @__PURE__ */ t.jsx("label", { htmlFor: s, className: (p = a == null ? void 0 : a.label) == null ? void 0 : p.className, children: n }),
    /* @__PURE__ */ t.jsx(
      "input",
      {
        className: N(
          (c = a == null ? void 0 : a.input) == null ? void 0 : c.className,
          l === !1 && h["no-arrows"]
        ),
        type: "text",
        id: s,
        placeholder: i,
        value: m,
        onChange: (r) => x(r.target.value),
        inputMode: "numeric",
        pattern: "[0-9]+",
        maxLength: 3,
        onInput: (r) => r.target.value = r.target.value.replace(/^[^1-9]/g, "").replace(/(\..*)\./g, "$1")
      }
    )
  ] });
};
export {
  E as default
};
